
export const getQtStart = (date) => {
  let d = date || new Date();
  let currMonth = d.getMonth();
  switch (currMonth) {
    case 0:
    case 1:
    case 2:
      return new Date(d.getFullYear(), 0);
    case 3:
    case 4:
    case 5:
      return new Date(d.getFullYear(), 3);
    case 6:
    case 7:
    case 8:
      return new Date(d.getFullYear(), 6);
    case 9:
    case 10:
    case 11:
      return new Date(d.getFullYear(), 9);
    default:
      return undefined;
  }
};

export const getPrevQtEnd = (date) => {
  return getQtStart(date).addDay(-1);
};